import { HandHeart, Leaf, Package } from "lucide-react";
import { site } from "@/content/liane-site.ar";
import { useReveal } from "@/hooks/use-reveal";

const icons = [HandHeart, Leaf, Package];

export function About() {
  const reveal = useReveal<HTMLDivElement>();

  return (
    <section id="about" className="py-16 lg:py-24">
      <div ref={reveal.ref} className={`container-liane ${reveal.className}`}>
        <div className="mx-auto max-w-3xl text-center">
          <span className="text-sm font-medium tracking-wide text-l-accent-strong">
            {site.about.kicker}
          </span>
          <h2 className="mt-3 text-2xl font-bold text-l-primary sm:text-3xl lg:text-4xl">
            {site.about.title}
          </h2>
          <p className="mt-5 text-base leading-8 text-l-muted-foreground sm:text-lg">
            {site.about.body}
          </p>
        </div>

        <ul className="mx-auto mt-9 flex max-w-3xl flex-wrap justify-center gap-3">
          {site.about.badges.map((badge, i) => {
            const Icon = icons[i] ?? Leaf;
            return (
              <li
                key={badge}
                className="inline-flex min-h-12 items-center gap-2 rounded-full border border-l-border bg-l-card px-5 text-sm text-l-foreground shadow-l-soft"
              >
                <Icon className="size-4 text-l-accent-strong" aria-hidden="true" />
                {badge}
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
